import React, { useState } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import gtm from 'eco-design-reliance/gtm';
import { StepProps } from '../createStateMachine';
import { RemoteInstallFormContext } from '../index';
import css from '../index.module.scss';
import { useLang } from '@/i18n';

const Disclaimer: React.FC<StepProps<RemoteInstallFormContext>> = ({ send }) => {
    const { t } = useLang('questionnaire');
    const [show, setShow] = useState(false);

    return (
        <div className={css.step}>
            <div className="step-head">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1766458160480/pc_shp2.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1766458160670/m_shp2.jpg"
                />
                <span>{t('step_head')}</span>
            </div>
            <div className="Disclaimer-title">{t('disclaimer')}</div>
            <div className="Disclaimer-agree">
                <input
                    id="disclaimer-agree"
                    type="checkbox"
                    checked={show}
                    onChange={(e) => {
                        setShow(e.target.checked);
                        gtm.push({ event: 'uaEvent', event_name: 'agree_checkbox', tag: e.target.checked ? 'Agree' : 'Disagree' });
                    }}
                />
                <label htmlFor="disclaimer-agree">{t('disclaimer_agree')}</label>
            </div>
            <div className="step-btns">
                <button
                    className="step-btn step-btn-prev"
                    onClick={() => {
                        send('BACK2');
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'form_pagination',
                            button_name: t('btn1'),
                            status: show ? 'Agree' : 'Disagree',
                        });
                    }}
                >
                    {t('btn1')}
                </button>
                <button
                    className={`step-btn step-btn-next ${!show ? 'step-btn-disabled' : ''}`}
                    onClick={() => {
                        if (!show) return;
                        send('next');
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'form_pagination',
                            button_name: t('btn2'),
                            status: 'Agree',
                        });
                    }}
                >
                    {t('btn2')}
                </button>
            </div>
        </div>
    );
};
export default Disclaimer;
